import React from "react";

function EventResult() {
  return (
    <div>
      <section
        style={{ marginTop: "90px" }}
        className="py-5 d-flex items-center bg-blue-1-05"
      >
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center text-14 fw-500 text-light-1 font-inter">
                <div className="col-auto">
                  <a href="/" className="cursor-pointer">
                    Home
                  </a>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      //   navigate("/event/list");
                    }}
                  >
                    Results
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="row py-50 justify-between items-center">
          <iframe
            id="inlineFrameExample"
            title="Inline Frame Example"
            width="100%"
            height="100vh"
            style={{ width: "100%", height: "100vh" }}
            src="https://www.sportstimingsolutions.in/results.php?e_id=83042&e_name=UST%20Trivandrum%20Marathon%202024"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default EventResult;
